import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import styles from './MarkAllAsRead.scss';

const MarkAllAsRead = ({ onClickMarkAllAsRead, staticTexts, isNotificationsEmpty }) => {

    const markAllAsReadHandler = () => {
        if (!isNotificationsEmpty) {
            onClickMarkAllAsRead()
        }
    };

    return (
        <div className={styles.contentHolder}>
            <div className={styles.notifications}>{staticTexts.notificationsTitle}</div>
            <Button
                className={styles.markAllAsRead}
                disabled={isNotificationsEmpty}
                variant='contained'
                onClick={markAllAsReadHandler}
                data-testid='alerts-popOver__mark-all-as-read'
            >
                { staticTexts.markAllAsRead }
            </Button>
        </div>
    );
};

MarkAllAsRead.propTypes = {
    onClickMarkAllAsRead: PropTypes.func.isRequired,
    isNotificationsEmpty: PropTypes.bool,
    staticTexts: PropTypes.shape({
        notificationsTitle: PropTypes.string,
        markAllAsRead: PropTypes.string
    }).isRequired
};

MarkAllAsRead.defaultProps = {
    isNotificationsEmpty: false,
};

export default MarkAllAsRead;
